export default "__VITE_ASSET__DW0pfboF__ 480w, __VITE_ASSET__N4d8gVYh__ 720w, __VITE_ASSET__Cz55FmHw__ 900w, __VITE_ASSET__DMFG7ohl__ 1100w";